import moment from "moment";
window.moment = moment;
window.moment.locale('ja');
